import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductModel, StorePageStore } from '@boxx/store-core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.page.html',
  styleUrls: ['./product-list.page.scss'],
})
export class ProductListCouponsPage implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>();

  products$: Observable<ProductModel[]>;

  previousProductOptions: any[];

  itemList: ProductModel[] = [];
  searchResults: any[] = [];

  isFiltering = false;

  loader: HTMLIonLoadingElement;

  translations: any;
  hasItemsselected: boolean = false;

  constructor(
    private storePageStore: StorePageStore,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private boxxUtils: BoxxUtilsService
  ) {
    this.translate
      .get(['STORE_MODULE', 'ERRORS', 'SUCCESS', 'ACTIONS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.handleLoading();
    this.handleSuccess();
    this.handleError();

    this.storePageStore.productsStore.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((productList) => {
        this.itemList = productList;
        this.searchResults = [];
        for(let i = 0; i < productList.length; i++){
          let isChecked = false;
          const prodSel = this.previousProductOptions.filter((item)=> (item.id === productList[i].id && item.checked));
          if(prodSel.length > 0){
            isChecked = true;
          }
          this.searchResults.push({
            id: productList[i].id,
            enabled: productList[i].enabled,
            name: productList[i].name,
            price: productList[i].price,
            unlimited: productList[i].unlimited,
            quantity: productList[i].quantity,
            media: productList[i].media,
            checked: isChecked
          });
        }
      });

    this.storePageStore.productsStore.fetched$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((fetched) => {
        if (!fetched) {
          this.storePageStore.productsStore.fetch();
        }
      });
  }

  checkSelected(){
    this.hasItemsselected = false;
    for(let i = 0; i < this.searchResults.length; i++){
      if(this.searchResults[i].checked){
        this.hasItemsselected = true;
        break;
      }
    }
  }

  selectProducts(){
    const prods = this.searchResults.filter((item)=> item.checked);
    this.modalCtrl.dismiss({data: prods});
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  search(searchTerm: any) {
    this.searchResults = this.itemList;

    if (!searchTerm.detail.value) {
      return;
    }

    this.searchResults = this.searchResults.filter(
      (item) =>
        item.name
          .toLowerCase()
          .indexOf((searchTerm?.detail?.value || '').toLowerCase()) > -1
    );
  }

  close() {
    this.modalCtrl.dismiss();
  }

  getFirstLetter(name){
    return name.charAt(0).toUpperCase();
  }

  private handleLoading() {
    this.storePageStore.productsStore.loading$
      .pipe(skip(1), takeUntil(this.destroyed$))
      .subscribe((loading) => {
        setTimeout(async () => {
          this.boxxUtils.handleLoading(loading);
        }, 200);
      });
  }

  private handleSuccess() {
    this.storePageStore.productsStore.success$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((success) => {
        if (success && success.after === 'DELETE_PRODUCT') {
          this.boxxUtils.showToastSuccess({
            message: this.translations.SUCCESS.STORE.PRODUCTS[
              success.after.toLowerCase()
            ],
          });
        }
      });
  }

  private handleError() {
    this.storePageStore.productsStore.error$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((error) => {
        if (error) {
          this.boxxUtils.showToastError({
            message:
              this.translations.ERRORS.STORE.PRODUCTS[
                error.after.toLowerCase()
              ],
          });
        }
      });
  }
}
